import { useCallback } from 'react';
import CodeMirror from '@uiw/react-codemirror';
import { html } from '@codemirror/lang-html';
import { markdown } from '@codemirror/lang-markdown';
import { solarizedDark } from '@uiw/codemirror-theme-solarized';
import { useEditorStore } from '../store/editor-store';
import type { DetectedFormat } from '../types';

interface EditorPaneProps {
  format: DetectedFormat;
}

export function EditorPane({ format }: EditorPaneProps) {
  const { source, setSource, liveSync } = useEditorStore();

  const handleChange = useCallback(
    (value: string) => {
      if (liveSync) {
        setSource(value);
      } else {
        useEditorStore.setState({ pendingSource: value, source: value });
      }
    },
    [liveSync, setSource]
  );

  const extensions = format === 'html' ? [html()] : [markdown()];

  return (
    <div className="h-full flex flex-col bg-[#002b36]">
      <div className="flex-1 overflow-hidden">
        <CodeMirror
          value={source}
          onChange={handleChange}
          extensions={extensions}
          theme={solarizedDark}
          height="100%"
          basicSetup={{
            lineNumbers: true,
            highlightActiveLineGutter: true,
            highlightActiveLine: true,
            foldGutter: true,
            dropCursor: true,
            indentOnInput: true,
            bracketMatching: true,
            closeBrackets: true,
            autocompletion: true,
          }}
        />
      </div>
    </div>
  );
}
